import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { isEmpty } from 'lodash'

const BreadcrumbLinks = ({
  breadcrumbListSchema,
  placeholders: {
    links
  } = {}
}) =>
  <Wrapper aria-label="Breadcrumb" data-breadcrumb>
    {!isEmpty(breadcrumbListSchema) && (
      <Helmet>
        <script type="application/ld+json">
          {
            JSON.stringify(breadcrumbListSchema)
          }
        </script>
      </Helmet>
    )}

    <ListWrapper>
      { links }
    </ListWrapper>
  </Wrapper>

BreadcrumbLinks.propTypes = {
  breadcrumbListSchema: PropTypes.shape({}),
  placeholders: PropTypes.shape({
    links: PropTypes.arrayOf()
  })
}

export default BreadcrumbLinks

const Wrapper = styled.nav`
  ${Mixin.responsive('padding', '0', '0 16px')}
  ${Mixin.responsive('margin', '20px auto', '20px auto 50px')}
`

const ListWrapper = styled.ol`
  margin: 0;
  padding: 0;
`
